AkLG = {
    MAX_WIDTH: 1080,
    MAX_HEIGHT: 180,
    MIME_TYPE: "image/jpeg",
    QUALITY: 0.7,
    showLoadingAlert: function (title="Ładowanie Danych",icon='info') {
        Swal.fire({
            icon: icon,
            title: title,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    },
    calculateSize: function (img, maxWidth, maxHeight) {
        let width = img.width;
        let height = img.height;

        // calculate the width and height, constraining the proportions
        if (width > height) {
            if (width > maxWidth) {
                height = Math.round(height * maxWidth / width);
                width = maxWidth;
            }
        } else {
            if (height > maxHeight) {
                width = Math.round(width * maxHeight / height);
                height = maxHeight;
            }
        }
        return [width, height];
    },
    ImageOptimizerImg: function (plik) {
        return new Promise((resolve, reject) => {
            const file = plik; // get the file
            const blobURL = URL.createObjectURL(file);
            const img = new Image();
            img.src = blobURL;
            /*img.onerror = function () {
                URL.revokeObjectURL(this.src);
                // Handle the failure properly
                console.log("Cannot load image");
            };*/
            img.onerror = reject
            img.onload = () => resolve(img.height)
            img.onload = function () {
                URL.revokeObjectURL(this.src);
                maxHeigt = AkLG.MAX_WIDTH * (img.height/img.width);
                const [newWidth, newHeight] = AkLG.calculateSize(img, AkLG.MAX_WIDTH, maxHeigt);
                const canvas = document.createElement("canvas");
                canvas.width = newWidth;
                canvas.height = newHeight;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, newWidth, newHeight);
                resolve(canvas)
                /*canvas.toBlob(
                    blob => {
                        // Handle the compressed image. es. upload or save in local state
                        //displayInfo('Original file', file);
                        //displayInfo('Compressed file', blob);
                        //let dupa = new File([blob], "filename.ext",{type:"mime/type", lastModified:new Date().getTime()});
                        let dupa = new File([blob], file.name, { type: file.type, lastModified: new Date().getTime() });
                        resolve(dupa)
                        //return dupa;
                    },
                    file.type,
                    AkLG.QUALITY
                );*/
                //document.getElementById("root").append(canvas);
            };
        })
    },
    ImageOptimizerBlob: function (plik,canvas) {
        return new Promise(function(resolve, reject) {
            canvas.toBlob(function(blob) {
                    resolve(blob)
                },
                plik.type,
                AkLG.QUALITY
            )
        })
    },
    ImageOptimizerFile: function (plik,blob) {
        return new Promise(function(resolve, reject) {
            let dupa = new File([blob], plik.name, { type: plik.type, lastModified: new Date().getTime() });
            resolve(dupa)
        })
    },
    updateImageDisplay: function () {
        list = this.parentNode.querySelector('.ak-lg-list');
        while(list.hasChildNodes()) {
            list.removeChild(list.firstChild);
        }

        curFiles = this.files;
        if(curFiles.length === 0) {
            para = document.createElement('p');
            para.textContent = 'Nie wybrano plików';
            list.appendChild(para);
        } else {
            listOl = document.createElement('ol');
            listOl.classList.add("draggable-list")
            list.appendChild(listOl);
            index = 0;
            for(file of curFiles) {
                //if (!file.type.startsWith('image/')){ continue }
                listOlItem = document.createElement('li');
                listOlItem.setAttribute('data-index', index);
                /*listOlItem.innerHTML = `
                    <span class="number">${index + 1}</span>
                    <div class="draggable" draggable="true">
                        <p class="person-name">${file.name}</p>
                        <img src="${URL.createObjectURL(file)}" name="${file.name}" type="${file.type}"">
                        <i hidden class="fas fa-grip-lines"></i>
                    </div>
                `;*/
                newElement = document.createElement('span');
                newElement.classList.add("number");
                newElement.innerHTML = `${index + 1}`;
                listOlItem.appendChild(newElement);
                newElementDiv = document.createElement('div');
                newElementDiv.classList.add("draggable");
                newElementDiv.setAttribute('draggable', true);
                newElement = document.createElement('p');
                newElement.classList.add("person-name");
                newElement.innerHTML = `${file.name}`;
                newElementDiv.appendChild(newElement);
                newElement = document.createElement('img');
                newElement.src = URL.createObjectURL(file);
                newElement.name = file.name;
                newElement.type = file.type;
                newElement.file = file;
                newElementDiv.appendChild(newElement);
                listOlItem.appendChild(newElementDiv);

                /*para = document.createElement('p');
                //if(validFileType(file)) {
                    //para.textContent = `File name ${file.name}, file size ${returnFileSize(file.size)}.`;
                    para.textContent = `File name ${file.name}.`;
                    image = document.createElement('img');
                    image.src = URL.createObjectURL(file);

                    listOlItem.appendChild(image);
                    listOlItem.appendChild(para);
                //} else {
                //    para.textContent = `File name ${file.name}: Not a valid file type. Update your selection.`;
                //    listOlItem.appendChild(para);
                //}*/

                listOl.appendChild(listOlItem);
                index++;
            }
        }
        /*draggables = list.querySelectorAll('.draggable');
        dragListItems = list.querySelectorAll('.draggable-list li');

        draggables.forEach(draggable => {
            draggable.addEventListener('dragstart', AkLG.dragStart);
        });

        dragListItems.forEach(item => {
            item.myList = dragListItems;
            item.addEventListener('dragover', AkLG.dragOver);
            item.addEventListener('drop', AkLG.dragDrop);
            item.addEventListener('dragenter', AkLG.dragEnter);
            item.addEventListener('dragleave', AkLG.dragLeave);
        });*/
        AkLG.dragListener(list);
    },
    createWtapper: function (odnosnik){
        parent = odnosnik.parentNode;
        wrapper = document.createElement('div');
        wrapper.classList.add("ak-lg-wrapper");
        wrapper.setAttribute("name", odnosnik.name);
        parent.replaceChild(wrapper, odnosnik);
        wrapper.appendChild(odnosnik);
        paradiv = document.createElement('div');
        paradiv.textContent = '';
        paradiv.classList.add("ak-lg-list")
        wrapper.appendChild(paradiv);
        odnosnik.addEventListener('click', function () {
            list = this.parentNode.querySelector('.ak-lg-list');
            while(list.hasChildNodes()) {
                list.removeChild(list.firstChild);
            }
        });
        odnosnik.addEventListener('change', AkLG.updateImageDisplay);
    },
    dragListener: function (list) {
        draggables = list.querySelectorAll('.draggable');
        dragListItems = list.querySelectorAll('.draggable-list li');

        draggables.forEach(draggable => {
            draggable.addEventListener('dragstart', AkLG.dragStart);
        });

        dragListItems.forEach(item => {
            item.myList = dragListItems;
            item.addEventListener('dragover', AkLG.dragOver);
            item.addEventListener('drop', AkLG.dragDrop);
            item.addEventListener('dragenter', AkLG.dragEnter);
            item.addEventListener('dragleave', AkLG.dragLeave);
        });
    },
    dragStart: function () {
        // console.log('Event: ', 'dragstart');
        dragStartIndex = +this.closest('li').getAttribute('data-index');
    },
    dragEnter: function () {
        // console.log('Event: ', 'dragenter');
        this.classList.add('over');
    },
    dragLeave: function () {
        // console.log('Event: ', 'dragleave');
        this.classList.remove('over');
    },
    dragOver: function (e) {
        // console.log('Event: ', 'dragover');
        e.preventDefault();
    },
    dragDrop: function (e) {
        // console.log('Event: ', 'drop');
        const dragEndIndex = +this.getAttribute('data-index');
        AkLG.swapItems(e.currentTarget.myList,dragStartIndex, dragEndIndex);

        this.classList.remove('over');
        e.preventDefault();
    },
    swapItems: function (listItems, fromIndex, toIndex) {
        // Swap list items that are drag and drop
        const itemOne = listItems[fromIndex].querySelector('.draggable');
        const itemTwo = listItems[toIndex].querySelector('.draggable');

        listItems[fromIndex].appendChild(itemTwo);
        listItems[toIndex].appendChild(itemOne);
    },
    gallery: {
        images: null,
        imgIndex: 0,
        create: function (src) {
            AkLG.gallery.images = document.querySelectorAll(`${src} img`);
            AkLG.gallery.imgIndex
            let imgSrc;
            // get images src onclick
            AkLG.gallery.images.forEach((img, i) => {
                img.addEventListener("click", (e) => {
                    imgSrc = e.target.src;
                    //run modal function
                    AkLG.gallery.imgModal(imgSrc);
                    //index of the next image
                    AkLG.gallery.imgIndex = i;
                });
            });
        },
        imgModal: function (src) {
            //creating the modal
            const modal = document.createElement("div");
            modal.setAttribute("class", "ak-lg-gallery modal-gallery");
            //add modal to the parent element 
            document.querySelector("body").append(modal);
            //adding image to modal
            const newImage = document.createElement("img");
            newImage.setAttribute("src", src);
            //creating the close button
            const closeBtn = document.createElement("i");
            closeBtn.setAttribute("class", "fas fa-times closeBtn");
            //close function
            closeBtn.onclick = () => {
                modal.remove();
            };
            //next and previous buttons
            const nextBtn = document.createElement("i");
            nextBtn.setAttribute("class", "fas fa-angle-right nextBtn");
            // change the src of current image to the src of next image
            nextBtn.onclick = () => {
                newImage.setAttribute("src", AkLG.gallery.nextImg())
            };
            const prevBtn = document.createElement("i");
            prevBtn.setAttribute("class", "fas fa-angle-left prevBtn");
            // change the src of current image to the src of pevious image
            prevBtn.onclick = () => {
                newImage.setAttribute("src", AkLG.gallery.prevImg())
            }
            modal.append(newImage, closeBtn, nextBtn, prevBtn);
        },
        nextImg: function () {
            //next image function
            AkLG.gallery.imgIndex++;
            //check if it is the the last image
            if (AkLG.gallery.imgIndex >= AkLG.gallery.images.length) {
                AkLG.gallery.imgIndex = 0
            }
            //return src of the new image
            return AkLG.gallery.images[AkLG.gallery.imgIndex].src;
        },
        prevImg: function () {
            //previous image function
            AkLG.gallery.imgIndex--;
            // console.log(imgIndex);
            //check if it is the first image
            if (AkLG.gallery.imgIndex < 0) {
                AkLG.gallery.imgIndex = AkLG.gallery.images.length - 1
            }
            //return src of previous image
            return AkLG.gallery.images[AkLG.gallery.imgIndex].src
        }
    },
    JSON: {
        getObjects: function (obj, key, val) {
            //return an array of objects according to key, value, or key and value matching
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getObjects(obj[i], key, val));    
                } else 
                //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
                if (i == key && obj[i] == val || i == key && val == '') { //
                    objects.push(obj);
                } else if (obj[i] == val && key == ''){
                    //only add if the object is not already in the array
                    if (objects.lastIndexOf(obj) == -1){
                        objects.push(obj);
                    }
                }
            }
            return objects;
        },
        getValues: function (obj, key) {
            //return an array of values that match on a certain key
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getValues(obj[i], key));
                } else if (i == key) {
                    objects.push(obj[i]);
                }
            }
            return objects;
        },
        getKeys: function (obj, val) {
            //return an array of keys that match on a certain value
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getKeys(obj[i], val));
                } else if (obj[i] == val) {
                    objects.push(i);
                }
            }
            return objects;
        }
    }
};